export const validateCurrency = (_, value) => {
  if (value === undefined || value === null) {
    return Promise.resolve();
  }
  const regex = /^\d+(\,\d{1,2})?$/;
  return regex.test(value.toString())
    ? Promise.resolve()
    : Promise.reject('Insira um valor válido');
};
